import {useAuthInfo} from "@propelauth/react";
import {CardContent, CardHeader, CardTitle,} from "../ui/card";
import React, {useContext, useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {fetchWithToken} from "../../api/apiBase";
import {Button} from "../ui/button";
import {UserContext} from "../../contexts/UserContext";
import BaseLoadingSpinner from "../ui/baseLoadingSpinner";
import {BaseScopeModel} from "./ScopeModel";
import {CompanyType} from "../../models/company";
import ScopeItemForm from "./CreateScope";
// import {QAModel} from "@/src/components/qa_forum/QAModel";
import {BidderScopeCard} from "./ScopeListItem";


type ScopePageProps = {
    creating : boolean
}

/**
 *
 * todo - add the newly created data to the list on submit.
 * done
 *
 * */
function BidderScopesPage() {

    const {accessToken} = useAuthInfo();
    const { project_id } = useParams<string>();

    const [data, setData] = useState<BaseScopeModel[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const fetchData = async () => {
        if(accessToken) {
            try {
                setIsLoading(true);
                const response = await fetchWithToken(`/projects/${project_id}/scopes`, accessToken);
                setData(response);
                console.log(response);
                setError(null);
            } catch (err) {
                setError("Error loading QA :(");
            } finally {
                setIsLoading(false);
            }
        }
    };

    useEffect(() => {
        fetchData()
    }, [project_id, accessToken]);

    if (isLoading) return <div><BaseLoadingSpinner/></div>;
    if (error)
        return (
            <div>Error loading QA :(</div>
        );

    return (
        <div className="space-y-6">
                <CardHeader>
                    <CardTitle>
                        <div className="flex justify-between items-center">
                            <h1 className="text-xm font-semibold">
                                Scopes
                            </h1>
                        </div>
                    </CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                    {data.length === 0?
                        "No Scopes to show"
                        : <>{data.map((qa: BaseScopeModel) => <BidderScopeCard scope={qa}/>)}</>
                    }
                </CardContent>
        </div>
    );
}

export default BidderScopesPage;
